// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeSelectionField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * TreeSelectionField component
 */
import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import TreeView from 'share/components/controls/Izenda.TreeView';
import Input from 'share/components/controls/Izenda.Input';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import action from './Izenda.TreeSelectionFieldAction';
import { get } from 'lodash/fp';

@connect(action)
export default class TreeSelectionField extends Component {
  static propTypes = {
    treeData: PropTypes.array
  };

  renderNode = (item, toggleIcon, toggle, isCollapsed, parent) => {
    return (
      <label className="overflow-text checkbox-inline">
        <Input
          type="checkbox"
          indeterminate={item.indeterminate}
          checked={item.checked}
          onChange={this.props.onChange.bind(this, item, parent)}
        />
        <OverflowText text={item.value} tooltip={item.value} />
      </label>
    );
  };

  render() {
    return (
      <TreeView
        nodes={this.props.treeData}
        renderNode={this.renderNode}
        getKey={get('key')}
        getChildNodes={get('nodes')}
        collapsed={false}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.TreeSelectionField.js